"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCategory = void 0;
var EventCategory;
(function (EventCategory) {
    EventCategory["Cart"] = "Cart";
    EventCategory["CustomerAccount"] = "CustomerAccount";
    EventCategory["AddressType"] = "AddressType";
    EventCategory["ProductList"] = "ProductList";
    EventCategory["ProductDetail"] = "ProductDetail";
    EventCategory["Search"] = "Search";
    EventCategory["NoResultsPage"] = "NoResultsPage";
    EventCategory["Wishlist"] = "Wishlist";
    EventCategory["DirectBooking"] = "DirectBooking";
    EventCategory["TopNavi"] = "TopNavi";
    EventCategory["Header"] = "Header";
    EventCategory["Navigation"] = "Navigation";
})(EventCategory || (exports.EventCategory = EventCategory = {}));
//# sourceMappingURL=EventCategory.js.map